import { Card, Title } from 'react-native-paper'

import Recipes from 'components/Recipes'

const List = ({ navigation }) => (
  <Recipes onPress={(recipe) => navigation.navigate('Recipe', recipe)}>
    <Card.Title
      title="Your meals"
      subtitle="The meals you selected for the week"
    />
    <Card.Content>
      <Title>Press on a meal to see it's cooking instructions.</Title>
    </Card.Content>
  </Recipes>
)

export default List
